import { render, staticRenderFns } from "./bookInfo.vue?vue&type=template&id=38a454c7&scoped=true&"
import script from "./bookInfo.vue?vue&type=script&lang=js&"
export * from "./bookInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookInfo.vue?vue&type=style&index=0&id=38a454c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a454c7",
  null
  
)

export default component.exports